import Section from '/components/elements/Section'
import Container from '/components/elements/Container'
import isEmpty from 'lodash-es/isEmpty'
import styles from './styles.module.scss'
import moment from 'moment'

const Updates = ({ title = 'Updates', entries }) => {
  if (entries && !isEmpty(entries)) {
    return (
      <Section>
        <Container variant={['-xs3']}>
          <h2 className={styles.title}>{title}</h2>

          <div>
            {entries.map((update, index) => (
              <div className={styles.update} key={`update-number-${index}`}>
                <div className={styles.update__left}>
                  <div className={styles.update__bullet}></div>
                </div>

                <div className={styles.update__content}>
                  <div className={styles.update__right}>
                    {moment(update.date).utc().format('DD MMM YYYY')}
                  </div>

                  <div
                    dangerouslySetInnerHTML={{
                      __html: update.description
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </Section>
    )
  }
  return
}

export default Updates
